import { FlatItem } from 'src/types/elements.type';
import { EmployeeShiftAdd, EmployeeShiftBreakTime, IEmployeeShift } from 'src/types/hr_ticket/employeeShift.type';
import { PagedList } from 'src/types/pagedList.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/employee-shifts';

export const getEmployeeShifts = async (
  searchCondition: string,
  page: number,
  pageSize: number,
  orderBy?: string,
  departmentId?: number | undefined
) => {
  return await http.get<PagedList<IEmployeeShift>>(`${controller}`, {
    params: {
      searchCondition: searchCondition,
      page,
      pageSize,
      orderBy,
      departmentId
    }
  });
};

export const getEmployeeShift = async (id: number) => {
  return http.get<IEmployeeShift>(`${controller}/${id}`);
};

export const addEmployeeShift = async (employeeShift: EmployeeShiftAdd) => {
  return http.post<IEmployeeShift>(controller, employeeShift);
};

export const updateEmployeeShift = async (id: number, employeeShift: IEmployeeShift) => {
  return await http.put<IEmployeeShift[]>(`${controller}/${id}`, employeeShift);
};

export const deleteEmployeeShift = async (id: number) => {
  return await http.delete(`${controller}/${id}`);
};

export const getEmployeeShiftsDropdown = async () => {
  return await http.get<FlatItem[]>(`${controller}/dropdown`);
};

export const getEmployeeShiftsBreakTime = async () => {
  return await http.get<EmployeeShiftBreakTime[]>(`${controller}/breaktime`);
};
